import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import Select from '@material-ui/core/Select';
import { Button, InputLabel, FormControl, Paper, OutlinedInput } from '@material-ui/core';
import DotIcon from '@material-ui/icons/Lens';
import Tooltip from '@material-ui/core/Tooltip';
import MaterialTable, { Options } from 'material-table';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import { receiveError } from '../../store/actions/notificationAction';
import { setDestinationGha }  from '../../store/actions/ghaAction';
import { receivePorts, setDestinationPort } from '../../store/actions/portAction';

import ghaRemote from '../../api/ghaRemote';
import paymentConnectRemote from '../../api/paymentConnectRemote';
import AchAccountLinkTermsAndConditionsModal from '../termsAndConditions/AchAccountLinkTermsAndConditionsModal';

import Ports from '../../models/Ports';
import GhaModel from '../../models/Gha';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import User, { UserRoleType } from '../../models/User';
import GhaHeaderOptionsModel from '../../models/GhaHeaderOptions';

import paymentOptStyles from './paymentOptions.module.css';
import commonStyles from '../common/common.module.css';

import { forwarderOptions, ghaSpecificOptions } from '../../configs/paymentOptions';

const PADDING_RIGHT = '14px';
const PADDING_LEFT = '14px';
const TABLE_OPTIONS: any = {
  paging: false,
  pageSize: 10,
  headerStyle: {
    backgroundColor: 'var(--tbl_head_bkg)',
    color: 'var(--tbl_head_color)',
    zIndex: 2,
  },
  showTitle: false,
  pageSizeOptions: [15, 20],
  toolbar: false,
  sorting: false,
  filtering: false,
};
const styles = (theme: Theme) =>

  createStyles({
    dotGridCell : {
      paddingRight: 14,
      paddingLeft: 14,
      textAlign: 'center'
    },
    select: {
      width: '200px',
      marginBottom: '30px',
      fontSize: '14px',
      '& select': {
        padding: '8px 12px',
        border: '1px solid black',
      }
    },
  });

interface PaymentOptionsProps {
  user: User;
  classes: any;
  ports: Ports;
  ghaInfo: GhaModel;
  userRole: UserRoleType;
  getPorts: (direction: 'org' | 'dst') => void;
  receiveError: (error: ResponseError) => void;
  setDestinationPort: (port: string) => void;
  setDestinationGha: (gha: number) => void;
};

interface PaymentOptionsState {
  ghaFetched: boolean;
  forwarderOptionsTable: any;
  activatedPayments: Array<[string, boolean]>;
  ghaSpecificOptions: Array<[string, boolean]>;
  linkButtonClicked: boolean;
  openAchLinkAccountConfirmationModal: boolean;
};

class PaymentOptionsContainer extends Component<PaymentOptionsProps, PaymentOptionsState> {

  state = {
    ghaFetched: false,
    forwarderOptionsTable: [],
    activatedPayments: [],
    ghaSpecificOptions: [],
    linkButtonClicked: false,
    openAchLinkAccountConfirmationModal: false
  };

  componentDidMount(): void {

    const activatedPayments: any = [ ...this.state.activatedPayments ];
    let forwarderOptionsTable: any = [ ...forwarderOptions ];

      if (this.props.user.forwarder_id) {
        paymentConnectRemote.getConnectedAch(this.props.user.forwarder_id).then((resp: ApiResponse<boolean>) => {

          const success: boolean | undefined = resp.success;
          const error: ResponseError | undefined = resp.error;

          activatedPayments.push(['ach', success]);

          if (error) {

            forwarderOptionsTable = forwarderOptionsTable.filter((option: any) => option.code !== 'ach');
            this.props.receiveError(error);
          };

          this.setState({ forwarderOptionsTable });
        });
      }

      forwarderOptions.forEach(( { code } ) => {

        if (code !== 'ach') {
          activatedPayments.push([code, true])
        }
      });

      this.setState({ activatedPayments });
    this.props.getPorts('dst');
  };

  onSuccess = (token: string, metadata: any): void => {

    if (!this.state.linkButtonClicked) {

      this.setState({ linkButtonClicked: true, openAchLinkAccountConfirmationModal: false });

      paymentConnectRemote.connectAch(token, metadata).then((resp: ApiResponse<boolean>) => {

        const success: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;

        if (success === true) {

          const activatedPayments: Array<[string, boolean]> = [ ...this.state.activatedPayments ];

          activatedPayments.forEach((payment: any) => {

            if (payment[0] === 'ach') {
              payment[1] = true;
            }
          });

          this.setState({ activatedPayments });
        }

        if (error) {
          this.props.receiveError(error);
          this.setState({ linkButtonClicked: false });
        };
      }).catch(e => {
        this.props.receiveError(e);
        this.setState({ linkButtonClicked: false });
      });
    }
  };

  handlePortChange = (event: any): void => {

    const port: string = event.target.value;

    if (!port) {
      this.setState({ ghaFetched: false });
      return;
    }

    const ghas: GhaHeaderOptionsModel  = this.props.ports[port][0];
    const gha: number = ghas.id;

    ghaRemote.getGhaInfo(gha, '').then((resp: ApiResponse<GhaModel>) => {

      const gha: GhaModel | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      const ghaSpecificOptions: Array<[string, boolean]> = [];

      if (gha && gha.gha_fwd_config) {

        ghaSpecificOptions[0] = ['invoice', gha.gha_fwd_config.pay_by_invoice_allowed];
        ghaSpecificOptions[1] = ['other', gha.gha_fwd_config.other_payment_allowed === 'yes' ? true : false];
      };

      this.setState({ ghaSpecificOptions, ghaFetched: true });

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  renderStatusColumn = (classes: any, payOption: any, paymentOptions: Array<[string, boolean]>): JSX.Element | null => {

    const payType: string = payOption.code;
    const active: boolean = paymentOptions.filter(optionArr => optionArr[0] === payType)[0][1];

    return <Tooltip title={ active ? 'Active' : 'Inactive' } aria-label="status">
             <DotIcon className={ active ? paymentOptStyles.green : paymentOptStyles.red } />
           </Tooltip>;
  }

  render() {

    const { classes } = this.props;
    const portsArr: Array<string> = Object.keys(this.props.ports);
    const portOptions: Array<JSX.Element> = portsArr.map((port: string , index: number) => (
      <option key={ index }>{ port }</option>
    ));

    return (

      <Fragment>

        { this.state.activatedPayments.length > 0 &&

          <Fragment>
            <div className={ paymentOptStyles.titleWrapper }>
              <h4>Global payment options</h4>
            </div>
            
            <div className={ commonStyles.wrapper }>
              <h1 className={ commonStyles.header }>Payment</h1>
              <MaterialTable

                components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

                columns={[
                  { title: 'Status',
                    cellStyle: { paddingRight: PADDING_RIGHT, paddingLeft: PADDING_LEFT, textAlign: 'center', width: '50px' },
                    headerStyle: { paddingRight: PADDING_RIGHT, paddingLeft: PADDING_LEFT, textAlign: 'center' },
                    render: (payOption: any) => this.renderStatusColumn(classes, payOption, this.state.activatedPayments)
                  },
                  { title: 'Payment Type', field: 'name' },
                  { title: 'Description', field: 'description' },
                  { title: 'Action',
                    render: (payOption: any) => {

                      const payType: string = payOption.code;
                      const activated: boolean = this.state.activatedPayments.filter(optionArr => optionArr[0] === payType)[0][1];

                      if (payType === 'ach' && !activated) {

                        return <Button 
                                 className={ paymentOptStyles.linkDisabledBtn }
                                 color="primary"
                                 variant="contained" 
                                 onClick={ () => this.setState({ openAchLinkAccountConfirmationModal: true })}
                               > 
                                 Link Account
                               </Button>;
                      }
                    }
                  }
                ]}

                data={ this.state.forwarderOptionsTable }
                options={ TABLE_OPTIONS }
              />
            </div>
          </Fragment>
        }

        <div className={ paymentOptStyles.ghaOptionsWrapper }>
          <div className={ paymentOptStyles.titleWrapper }>
            <h4>Specific payment options</h4>
          </div>

          <FormControl variant="outlined" className={ paymentOptStyles.inputLabelWrapper }>
            <label className={ commonStyles.inputLabel }> GHA Port </label>
            <Select native
              onChange={ this.handlePortChange }
              inputProps={{ name: 'port', id: 'port' }}
              className={ classes.select }
              disabled={ portOptions.length === 0 }
            >
            <option aria-label="None" value="" />
            { portOptions }
            </Select>
          </FormControl>

        </div>

        { this.state.ghaFetched && this.state.ghaSpecificOptions.length > 0 &&

          <div className={ commonStyles.wrapper }>
            <h1 className={ commonStyles.header }>Payment</h1>
            <MaterialTable

              components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
              
              columns={[
                { title: 'Status',
                  cellStyle: { paddingRight: 0, paddingLeft: 0, textAlign: 'center', width: '50px' },
                  headerStyle: { paddingRight: 0, paddingLeft: 0, textAlign: 'center' },
                  render: (payOption: any) => this.renderStatusColumn(classes, payOption, this.state.ghaSpecificOptions)
                },
                { title: 'Payment Type', field: 'name' },
                { title: 'Description', field: 'description',
                  cellStyle: { width: '47.5%', paddingLeft: 0 },
                  headerStyle: { width: '47.5%', paddingLeft: 0 }
                },
                { title: 'Action', headerStyle: { paddingRight: 0 },
                  render: (payOption: any) => { }
                }
              ]}

              data={ ghaSpecificOptions }
              options={ TABLE_OPTIONS }
            />
          </div>
        }

        { this.state.ghaFetched && this.state.ghaSpecificOptions.length === 0 &&
          <p className={ paymentOptStyles.paymentContent }>No additional payment options configured for this GHA/Port.</p>
        }

        { this.state.openAchLinkAccountConfirmationModal &&
          <AchAccountLinkTermsAndConditionsModal 
            openModal={ this.state.openAchLinkAccountConfirmationModal }
            closeModal={ () => this.setState({ openAchLinkAccountConfirmationModal: false }) }
            onSuccess={ this.onSuccess }
          />
        }

      </Fragment>
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    ports: state.destinationPorts,
    ghaInfo: state.ghaInfo
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    getPorts: (direction: 'org' | 'dst') => dispatch(receivePorts(direction)),
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    setDestinationPort: (port: string) => dispatch(setDestinationPort(port)),
    setDestinationGha: (gha: number) => dispatch(setDestinationGha(gha)),
  };
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(PaymentOptionsContainer));